import { KeyedMutator } from "swr"
import { readAllNotificationUser, readNotificationUser } from "../api/Notification"

import Swal from "sweetalert2"
import useAccessToken from "./AccessToken"
import { useIntl } from "react-intl"
import useNotificationStore from "../stores/Notification"

interface UseHandleReadNotifProps {
    mutateNotif?: KeyedMutator<any>
}

const useHandleReadNotif = ({ mutateNotif }: UseHandleReadNotifProps) => {
    const token = useAccessToken()
    const intl = useIntl()
    const { listCheckedNotification, setListCheckedNotification } = useNotificationStore()

    const handleReadAllNotification = async () => {
        try {
            const response = await readAllNotificationUser(token)
            if (response.status) {
                mutateNotif?.()
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: intl.formatMessage({ id: 'NOTIFICATION.SUCCESS.READ_ALL' }),
                })
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            })
        }
    }

    const handleReadNotification = async () => {
        try {
            listCheckedNotification.forEach(async (notif) => {
                const response = await readNotificationUser(notif.id, token)
                if (response.data.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: intl.formatMessage({ id: 'NOTIFICATION.SUCCESS.READ' }),
                    })
                    setListCheckedNotification([])
                    mutateNotif?.()
                }
            })
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            })
        }
    }

    return {
        handleReadAllNotification,
        handleReadNotification,
        mutateNotif
    }
}

export default useHandleReadNotif